var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlackhansa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 186.55,
    height: 28,
    viewBox: "0 0 186.55 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 186.55,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M5.355,9.755h.077A6.529,6.529,0,0,1,11.323,6.58c4.475,0,8.453,3.443,8.453,10.481,0,5.585-2.525,10.94-8.568,10.94a6.463,6.463,0,0,1-5.891-3.1H5.241v2.563H0V0H5.355Zm4.361,1.454c-3.672,0-4.59,3.29-4.59,6.541,0,3.022,1.339,5.852,4.743,5.852,3.443,0,4.4-3.749,4.4-6.158,0-3.213-1.147-6.235-4.552-6.235",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 5.355,
    height: 27.465,
    transform: "translate(21.383 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M88.965,33.278c0,2.41.536,2.945,1.186,3.175v.8H84.376a8.9,8.9,0,0,1-.5-2.41,8.285,8.285,0,0,1-6.58,2.945c-3.059,0-6.2-1.722-6.2-5.929,0-3.978,2.525-6.006,5.929-6.5l4.82-.727c.842-.115,1.874-.459,1.874-1.607,0-2.257-2.142-2.371-3.519-2.371-2.677,0-3.136,1.644-3.289,2.83H71.752c.612-6.235,4.935-7.115,9.1-7.115,2.869,0,8.109.88,8.109,5.891Zm-5.24-5.929c-.535.421-1.415.765-3.634,1.109-1.989.344-3.634.842-3.634,3.06a2.336,2.336,0,0,0,2.486,2.448c2.372,0,4.781-1.53,4.781-4.016Z",
    transform: "translate(-42.528 -9.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M138.446,29.837c-.191,2.1-1.836,7.956-9.3,7.956-7.65,0-9.409-5.852-9.409-10.136,0-6.579,2.869-11.284,9.754-11.284,3.213,0,8.491,1.454,8.989,7.8h-5.432c-.229-1.3-.994-3.29-3.289-3.29h-.268c-3.366,0-4.246,3.366-4.246,5.891,0,2.219.077,6.618,4.131,6.618a3.735,3.735,0,0,0,3.634-3.557Z",
    transform: "translate(-71.621 -9.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M174.687,27.465h-5.355V0h5.355V14.842l6.733-7.727H188l-7.191,7.88,7.382,12.47h-6.426l-4.858-8.721-2.219,2.3Z",
    transform: "translate(-101.283 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M235.513,27.465h-5.355V15.109c0-1.491-.076-4.016-3.481-4.016-2.371,0-4.208,1.606-4.208,4.7V27.465h-5.355V0h5.355V9.754h.076c.689-1.683,2.984-3.175,5.891-3.175,3.978,0,7.077,2.334,7.077,6.809Z",
    transform: "translate(-129.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M284.947,33.278c0,2.41.536,2.945,1.186,3.175v.8h-5.776a8.926,8.926,0,0,1-.5-2.41,8.284,8.284,0,0,1-6.58,2.945c-3.06,0-6.2-1.722-6.2-5.929,0-3.978,2.525-6.006,5.929-6.5l4.82-.727c.842-.115,1.874-.459,1.874-1.607,0-2.257-2.142-2.371-3.519-2.371-2.677,0-3.137,1.644-3.289,2.83h-5.164c.612-6.235,4.935-7.115,9.1-7.115,2.869,0,8.109.88,8.109,5.891Zm-5.24-5.929c-.535.421-1.415.765-3.634,1.109-1.989.344-3.634.842-3.634,3.06a2.336,2.336,0,0,0,2.486,2.448c2.372,0,4.781-1.53,4.781-4.016Z",
    transform: "translate(-159.751 -9.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M337.073,37.257h-5.355V24.9c0-1.491-.076-4.016-3.481-4.016-2.371,0-4.208,1.606-4.208,4.7V37.257h-5.355V16.907H323.8v2.984h.076a6.553,6.553,0,0,1,6.12-3.52c3.978,0,7.077,2.334,7.077,6.809Z",
    transform: "translate(-190.609 -9.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M381.592,23.1c-.229-1.3-.688-2.678-3.6-2.678s-3.29,1.11-3.29,1.99c0,3.213,12.738.879,12.738,8.377,0,5.929-5.737,7-8.913,7-4.628,0-9.639-1.606-9.792-7.038h5.508c0,1.722,1.071,2.984,4.437,2.984,2.754,0,3.4-1.339,3.4-2.1,0-3.4-12.623-.842-12.623-8.454,0-2.983,1.874-6.809,8.224-6.809,3.978,0,8.721,1,9.142,6.733Z",
    transform: "translate(-220.554 -9.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M434.669,33.278c0,2.41.536,2.945,1.186,3.175v.8h-5.776a8.925,8.925,0,0,1-.5-2.41A8.284,8.284,0,0,1,423,37.792c-3.06,0-6.2-1.722-6.2-5.929,0-3.978,2.525-6.006,5.929-6.5l4.82-.727c.841-.115,1.874-.459,1.874-1.607,0-2.257-2.142-2.371-3.519-2.371-2.677,0-3.137,1.644-3.289,2.83h-5.164c.612-6.235,4.935-7.115,9.1-7.115,2.869,0,8.109.88,8.109,5.891Zm-5.24-5.929c-.535.421-1.415.765-3.634,1.109-1.989.344-3.634.842-3.634,3.06a2.336,2.336,0,0,0,2.486,2.448c2.372,0,4.781-1.53,4.781-4.016Z",
    transform: "translate(-249.305 -9.792)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackhansa);
export default __webpack_public_path__ + "static/media/blackhansa.c98f1ebcf4e320f01a6fb4d46e0f6f53.svg";
export { ForwardRef as ReactComponent };